<template>
  <v-card>
    <v-card-title>{{ $t('application.competitors') }}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="this.data.applicationCompetitors"
        hide-default-headers
        hide-default-footer
        disable-pagination
        disable-sort
      >
      <template v-slot:item.name="{item}">
        <router-link v-if="$store.getters['isAdministrator']" :to="'/app/competitors/'+item.competitor.id">
          {{ item.competitor.firstName }}
          {{ item.competitor.lastName }}
        </router-link>
        <div v-else>{{ item.competitor.firstName }} {{ item.competitor.lastName }}</div>
      </template>
      <template v-slot:item.checkin="{item}">
        <v-icon color="green" v-if="item.competitor.checkIns.find(c => c.competitionId == data.competitionId)">check_circle</v-icon>
        <v-icon color="red" v-else>cancel</v-icon>
      </template>
      <template v-slot:item.participation="{item}">
        <v-icon color="green" v-if="item.participationConfirmed">check_circle</v-icon>
        <v-btn color="success" @click="confirm" v-else-if="item.competitorId == $store.getters['user'].id" >{{ $t('ctrl.confirm')}}</v-btn>
        <v-icon color="red" v-else>cancel</v-icon>
      </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    VTooltip,
    VForm,
    VTextField,
    VCard,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable
  } from 'vuetify/lib'
  import fccapi from '../../fccapi.js'

  export default {
    name: 'FCCApplicationCompetitors',
    computed: {
      headers: function(){
        return [
          { text: this.$t('competitor.name'), value: 'name', align: 'left' },
          { text: this.$t('competitor.department'), value: 'competitor.department', align: 'left' },
          { text: this.$t('competitor.checkedIn'), value: 'checkin', align: 'left' },
          { text: this.$t('competitor.participation'), value: 'participation', align: 'left' },
        ];
      }
    },
    methods: {
      confirm: function(){
        fccapi.post(`applications/${this.$route.params.id}/confirm`, null).then(e => {
          console.log(e);
          this.reload();
        }).catch(e => {
          console.log(e);
        })
      }
    },
    props: {
      data: Object,
      reload: Function
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable
    }
  }
</script>